<template>
    <v-dialog v-model="modalProp" width="500">
        <v-card>
            <v-card-title class="headline grey lighten-2">
                Change Cellphone #
                <v-spacer />
                <v-btn
                    icon
                    @click="modalProp = false"
                >
                    <v-icon> {{ mdiClose }}</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="mt-6">
                <!-- Current Cellphone Number -->
                <v-text-field
                    v-mask="cpNoMask"
                    label="Current cellphone #"
                    :value="userCpno"
                    color="green accent-4"
                    autocomplete="nope"
                    readonly
                />

                <!-- New Cellphone number -->
                <v-text-field
                    v-model="newCpno"
                    v-mask="cpNoMask"
                    label="Enter new cellphone #"
                    :rules="rules.contactRule"
                    color="green accent-4"
                    autocomplete="nope"
                    @keypress.enter="updateCpno()"
                />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-spacer />
                <v-btn color="green" text @click="updateCpno()">
                    Update
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { mask } from 'vue-the-mask'
import { mdiClose } from '@mdi/js'
export default {
    directives: {
        mask
    },
    props: ['editCpNo', 'userCpno'],
    data: () => ({
        mdiClose,
        newCpno: '',
        cpNoMask: '###########',
        rules: {
            contactRule: [
                (validation) => !!validation || 'Contact number is required',
                (validation) => /^[0-9() ]+$/.test(validation) || 'Invalid Input, numbers only'
            ]
        }
    }),
    computed: {
        modalProp: {
            get() {
                return this.editCpNo
            },
            set(val) {
                this.$emit('showDlgEditCpNo', val)
            }
        }
    },
    methods: {
        ...mapActions(['manageAccountCPno']),
        updateCpno() {
            if(this.newCpno != '' && /^[0-9() ]+$/.test(this.newCpno)){
                this.manageAccountCPno({
                    MEMBN: this.$cookies.get('usermembn'),
                    NEW_CPNO: this.newCpno
                }).then(() =>{
                    this.modalProp = false
                }).then(() => {
                    window.location.reload()
                })
            }
        }
    }
}
</script>

<style></style>
